import registerLangStoreModule from './lang';

const setupModules = (store, i18n) => {
	// Register Modules
	registerLangStoreModule(store, i18n);
};

export default setupModules;
